/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Sat May 13 2023
 **/

import { useMemo } from "react";

import { useStompManager } from "@/frameworks/libraries/network";
import { Configure } from "@/frameworks/libraries/utilities";
import { usePersistUser } from "@/frameworks/core/persistence";
import { Properties } from "@/frameworks/libraries";

import { Topics } from "../commons";

const LOGTAG = "#useNetworkCommand#";

export default function useNetworkCommand() {
	const stompNetwork = useStompManager();
	const me = usePersistUser("me");

	return useMemo(
		() => ({
			room: {
				join(roomID: string) {
					stompNetwork.publish("/XRM/Media", "joinRoom", { roomID });
				}
			},
			request(topic: Topic, payload: any) {
				stompNetwork.publish(topic, "request", payload);
			},
			typing(roomID: string, payload: any) {
				stompNetwork.publish(Topics.ToRoom(roomID), "typing", payload);
			},
			deviceMediaState: {
				call(subjectID: string, payload: any) {
					stompNetwork.publish(Topics.ToCall(subjectID), "deviceMediaState", payload);
				},
				callUser(subjectID: string, userID: string, payload: any) {
					stompNetwork.publish(Topics.ToCallUser(subjectID, userID), "deviceMediaState", payload);
				},
				voiceChat(subjectID: string, payload: any) {
					stompNetwork.publish(Topics.ToRoom(subjectID), "deviceMediaState", payload);
				}
			},
			requestLocation(peerID: string) {
				console.debug(LOGTAG, "requestLocation to", Topics.ToPeer(peerID));
				stompNetwork.publish(Topics.ToPeer(peerID), "requestLocation", {
					requesterID: Configure.userID,
					deviceKey: Properties.browserTabID
				} as ChatServices.C2C.RequestLocation.Data);
			},
			responseLocation(peerID: string, payload: IPC.Spaces.MyLocation) {
				stompNetwork.publish(Topics.ToPeer(peerID), "responseLocation", payload);
			},
			startScreenShare(callID: string, userID: string) {
				stompNetwork.publish(Topics.ToCall(callID), "startScreenShare", { callID, userID: userID });
			},
			stopScreenShare(callID: string, userID: string) {
				stompNetwork.publish(Topics.ToCall(callID), "stopScreenShare", { callID, userID: userID });
			},
			requestSummonFriend(peerID: string) {
				stompNetwork.publish(Topics.ToPeer(peerID), "requestSummonFriend", {
					requesterID: Configure.userID,
					requesterName: me.name || me.username
				});
			}
		}),
		[me]
	);
}
